<agpr-dialog-container
    [id]="id + '.expiryConfirmDialog'"
    [heading]="'Core.session.sessionExpiry.heading'"
    (close)="ok()"
>
    <div class="agpr-confirmDialog-content">
        <agpr-scroll-panel>
            <agpr-message [severity]="messageSeverityEnum.warning">
                {{ 'Core.session.sessionExpiry.warning' | localize }}
                {{ 'Core.session.sessionExpiry.warning.extension' | localize: { time: counter() } }}
            </agpr-message>
        </agpr-scroll-panel>
    </div>

    <ng-template #footerRight>
        <agpr-button
            [id]="id + '.expiryConfirmDialog.ok'"
            [label]="'Core.session.sessionExpiry.extend'"
            [style]="buttonTypes.primary"
            (click)="ok()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
